import React, { useEffect, useState } from "react";
import { MyContext } from "../../context";
import { mergeStyleSets, IconButton, ComboBox, Checkbox, MessageBar, MessageBarType } from "office-ui-fabric-react";
import StartEndTimePicker from "./StartEndTimePicker";

const classNames = mergeStyleSets({
    cardContainer: {
        position: "relative",
        padding: "10px 20px ",
        border: "1px solid #ccc",
        borderRadius: "4px",
        width: "100%",
    },
    trashIcon: {
        color: "red",
        position: "absolute",
        top: "10px",
        right: "10px",
    },
    flexContainer: {
        display: "flex",
        alignItems: "center",
    },
    dayCheckbox: {
        marginBottom: "7px",
        marginRight: "10px",
    },
    required: {
        color: "rgb(164, 38, 44)",
    },
});
const ProfileRuleScheduleCard = ({ style, index, deleteSchedule, updateSchedule, data, isDuplicate }) => {
    // Initialize state with default values for new schedules
    const defaultState = {
        period: "daily",
        globalStartTime: null,
        globalEndTime: null,
        interval: null,
        week: {
            monday: { isActive: false},
            tuesday: { isActive: false},
            wednesday: { isActive: false},
            thursday: { isActive: false},
            friday: { isActive: false},
            saturday: { isActive: false},
            sunday: { isActive: false},
        },
    };
    const [state, setState] = useState(data || defaultState);

    const updateState = (key, value) => {
        setState((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };
    const updateNestedState = (key1, key2, newValue) => {
        updateState(
            key1,
            key2
                ? {
                    ...state[key1],
                    [key2]: {
                        ...state[key1]?.[key2],
                        ...newValue,
                    },
                }
                : {
                    ...state[key1],
                    ...newValue,
                }
        );
    };
    useEffect(() => {
        updateSchedule("schedule", index, state);
    }, [state]);

    return (
        <MyContext.Consumer>
            {(context) => (
                <div style={style} className={classNames.cardContainer}>
                    {/* HEADER */}
                    <h5>
                        {context.getTranslation("recordingRule", "scheduleCardTitle")} #{index}
                    </h5>
                    <IconButton
                        iconProps={{ iconName: "Delete" }}
                        className={classNames.trashIcon}
                        onClick={() => {
                            deleteSchedule("schedule", index);
                        }}
                    />
                    {/* Duplicate error banner */}
                    {isDuplicate && (
                        <MessageBar messageBarType={MessageBarType.error}>
                            {context.getTranslation("recordingRule", "duplicateScheduleBanner")}
                        </MessageBar>
                    )}
                    {/* MAIN CONTENT */}
                   
                    <div style={{ marginTop: "3px" }} className={classNames.flexContainer}>
                        <p style={{ marginTop: "7px", marginRight: "10px" }}>{context.getTranslation("recordingRule", "period")}</p>
                        <ComboBox
                            style={{ width: "100px" }}
                            selectedKey={state.period}
                            options={[
                                {
                                    key: "daily",
                                    text: context.getTranslation("tenants", "daily"),
                                },
                                {
                                    key: "weekly",
                                    text: context.getTranslation("tenants", "weekly"),
                                },
                                {
                                    key: "monthly",
                                    text: context.getTranslation("tenants", "monthly"),
                                },
                            ]}
                            onChange={(event, newValue) => {
                                updateState("period", newValue.key);
                            }}
                        />
                    </div>
                    {state.period === "daily" && (
                        <StartEndTimePicker
                            style={{ marginTop: "10px" }}
                            startTime={state.globalStartTime}
                            endTime={state.globalEndTime}
                            updateState={updateState}
                            updateNestedState={updateNestedState}
                            nested={false}
                            startKey="globalStartTime"
                            endKey="globalEndTime"
                        />
                    )}
                    {state.period === "weekly" && (
                        <div style={{ marginTop: "10px" }}>
                            <StartEndTimePicker
                                startTime={state.globalStartTime}
                                endTime={state.globalEndTime}
                                updateState={updateState}
                                updateNestedState={updateNestedState}
                                nested={false}
                                startKey="globalStartTime"
                                endKey="globalEndTime"
                            />
                            <p>
                                {context.getTranslation("recordingRule", "chooseDays")} <span className={classNames.required}>*</span>
                            </p>
                           
                            {Object.keys(state.week).map((day) => (
                                <div key={day} className={classNames.flexContainer}>
                                    <Checkbox
                                        className={classNames.dayCheckbox}
                                        label={context.getTranslation("common", day)}
                                        checked={state.week[day].isActive}
                                        onChange={(event, newValue) => {
                                            updateNestedState("week", day, { isActive: newValue });
                                        }}
                                    />
                             
                                </div>
                            ))}
                        </div>
                    )}
                    {state.period === "monthly" && (
                        <div style={{ marginTop: "10px" }}>
                            <div className={classNames.flexContainer}>
                                <StartEndTimePicker
                                    startTime={state.globalStartTime}
                                    endTime={state.globalEndTime}
                                    updateState={updateState}
                                    updateNestedState={updateNestedState}
                                    nested={false}
                                    startKey="globalStartTime"
                                    endKey="globalEndTime"
                                />
                                <div style={{ display: "flex" }}>
                                <ComboBox
                                    style={{ width: "130px", marginBottom: "10px", marginLeft: "20px" }}
                                    selectedKey={state.interval}
                                    placeholder={context.getTranslation("recordingRule", "chooseWeek")}
                                    options={[
                                        {
                                            key: "first",
                                            text: context.getTranslation("recordingRule", "first"),
                                        },
                                        {
                                            key: "second",
                                            text: context.getTranslation("recordingRule", "second"),
                                        },
                                        {
                                            key: "third",
                                            text: context.getTranslation("recordingRule", "third"),
                                        },
                                        {
                                            key: "fourth",
                                            text: context.getTranslation("recordingRule", "fourth"),
                                        },
                                        {
                                            key: "last",
                                            text: context.getTranslation("recordingRule", "last"),
                                        },
                                    ]}
                                    onChange={(event, newValue) => {
                                        updateState("interval", newValue.key);
                                    }}
                                    />
                                    <span className={classNames.required} style={{ marginLeft: 4 }}>*</span>

                                </div>
                            </div>
                            <p>
                                {context.getTranslation("recordingRule", "chooseDays")} <span className={classNames.required}>*</span>
                            </p>
                            {Object.keys(state.week).map((day) => (
                                <div key={day} className={classNames.flexContainer}>
                                    <Checkbox
                                        className={classNames.dayCheckbox}
                                        label={context.getTranslation("common", day)}
                                        checked={state.week[day].isActive}
                                        onChange={(event, newValue) => {
                                            updateNestedState("week", day, { isActive: newValue });
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </MyContext.Consumer>
    );
};

export default ProfileRuleScheduleCard;
